import * as jQuery from 'jquery';

const mainWindow: any = window;
mainWindow['$'] = mainWindow['jQuery'] = jQuery;

const result: any = jQuery;
export default result;
